/**
 * Categorical series colors, drawn from the Mantine theme palette so they follow
 * the design system (and its dark-mode overrides). Distinct hues assigned in this
 * fixed order, never cycled: a chart shows at most SERIES_COLORS.length series and
 * folds the rest into "Other". Some slots sit below 3:1 contrast on white, so every
 * chart carries a legend and a table view of the same numbers.
 */
export const SERIES_COLORS = [
  "var(--mantine-color-blue-6)",
  "var(--mantine-color-orange-6)",
  "var(--mantine-color-teal-6)",
  "var(--mantine-color-yellow-6)",
  "var(--mantine-color-pink-4)",
  "var(--mantine-color-green-8)",
  "var(--mantine-color-violet-8)",
] as const;

export const OTHER_COLOR = "var(--mantine-color-gray-6)";
export const OTHER_SERIES = "__other__";
